export const DTSTransferMessage = (
  disableDTS: boolean,
  activeDTSVersion: number,
  isDTSVersionPresent: boolean,
  status: string,
  hasError: boolean,
  value: number | undefined,
) => {
  const isDraftStatus =
    status === "Save Draft" || status === "Admin creates draft";

  if (disableDTS) {
    return (
      <span className="dts-helper-text">
        Please select MSD compound, Supplier and Transfer ID to enable the DTS
        version
      </span>
    );
  }

  if (!disableDTS && activeDTSVersion > 0 && !hasError) {
    if (!isDraftStatus) {
      return (
        <span className="dts-helper-text">
          Last active version for this compound and transfer ID was{" "}
          {activeDTSVersion.toFixed(1)}.
        </span>
      );
    }
  }

  return null;
};

export const validateDTSVersion = (
  value: any,
  activeDTSVersion: number,
  status: string,
  isDTSVersionPresent: boolean,
) => {
  const isDraftStatus =
    status === "Save Draft" || status === "Admin creates draft";

  if (
    activeDTSVersion >= value &&
    activeDTSVersion > 0 &&
    !isDraftStatus
  ) {
    return Promise.reject(
      new Error(
        `Version must be greater than ${activeDTSVersion.toFixed(1)}. Last active version for this compound and transfer ID was ${activeDTSVersion.toFixed(1)}.`,
      ),
    );
  }

  if (
    activeDTSVersion > value &&
    isDraftStatus
  ) {
    return Promise.reject(
      new Error(
        `Version must be greater than or equal to ${activeDTSVersion.toFixed(1)}`,
      ),
    );
  }

  const singleDecimalPattern = /^\d+\.\d$/;
  if (singleDecimalPattern.test(value)) {
    return Promise.reject(
      new Error("DTS versions must exist in whole numbers (ex: 1.0, 2.0, 3.0, etc…)."),
    );
  }
  return Promise.resolve();
};

export const changeOfDescriptionMessage = (value: string, disable: boolean) => {
  if (value === "Original publication" && disable) {
    return null;
  }
  if (value === null || disable) {
    return (
      <span className="dts-helper-text">
        Please select MSD compound, Supplier, Transfer ID and DTS version to auto populate the Description of Change
      </span>
    );
  }
  return null;
};

export const validateDataFormat = () => {
  return (_: any, value: any) => {
    if (!value || value.length === 0) {
      return Promise.resolve();
    }

    const fileNames = value.map((file: any) => file.name);
    const hasDuplicates = new Set(fileNames).size !== fileNames.length;

    if (hasDuplicates) {
      return Promise.reject(
        new Error(
          "Multiple files with the same name are not accepted. Please re-try using a different file name.",
        ),
      );
    }

    if(value.length > 1) {
      return Promise.reject(new Error("Multiple files are not accepted."));
    }
    // Check file type
    const file = value[0];
    if (!file.name.endsWith(".pdf")) {
      return Promise.reject(new Error("Only .pdf files are permitted."));
    }

    return Promise.resolve();
  };
};

export const shouldShowDataFormat = (status: string, editScreen: boolean) => {
  return !((status === "Save Draft" || status === "Cancelled" || status === "Cancel offline DTS transfer") && !editScreen);
};
